<div class="appbased-tv__brand-selection">
  <div class="app-based-tv__brand-selection__body px-12">
    <div class="appbased-tv__brand-selection__sub-body container">
      <div class="appbased-tv__brand-selection__cta-list container">
        <div class="container-logp d-flex justify-content-between">
          <img class="appbased-tv__brand-selection__sub-body__image" src="assets/images/Rogers_Xfinity.png" tabindex="0" role="img" [alt]="'global.logo.altXfinity' | translate"/>
          <p class="pt-3"><rch-language-toggle [variant]="CTATypes.TERTIARY"></rch-language-toggle></p>
        </div>
        <div class="appbased-tv__brand-selection__cta-list__content" tabindex="0" role="text" [innerHTML]="'global.brand-selection.header' | translate"></div>
        <button
          ds-button 
          class="appbased-tv__brand-selection__cta-list__cta"
          [variant]="CTATypes.PRIMARY" 
          (click)="redirectTo(false)"
          [attr.aria-label]="'global.brand-selection.rogersCTA' | translate"
          [attr.title]="'global.brand-selection.rogersCTA' | translate"
          type="submit">
          <span class="appbased-tv__brand-selection__cta-list__cta-title">{{'global.brand-selection.rogersCTA' | translate}}</span>
        </button>

        <button
          ds-button 
          class="appbased-tv__brand-selection__cta-list__cta"
          [variant]="CTATypes.PRIMARY" 
          (click)="redirectTo(true)"
          [attr.aria-label]="'global.brand-selection.shawCTA' | translate"
          [attr.title]="'global.brand-selection.shawCTA' | translate"
          type="submit">
          <span class="appbased-tv__brand-selection__cta-list__cta-title">{{'global.brand-selection.shawCTA' | translate}}</span>
        </button>  
      </div>
    </div>
  </div>
</div>
